import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';

/**
 * Create the resetToMainLine method.
 */
export function createResetToMainLine(context: API.Context) {
  /**
   * Reset the game to the main line.
   */
  return function resetToMainLine(): API.Response {
    const { api, game, respond } = context;

    game.resetToMainLine();

    return respond(Core.APIEvents.ResetToMainLine, {
      pieces: api.getPieces(),
    });
  };
}
